export default function () {
  return [
    {name: 'Ene', meta: 20, monto: 10, anterior: 10},
    {name: 'Mar', meta: 20, monto: 5, anterior: 11},
    {name: 'Abr', meta: 24, monto: 5, anterior: 12},
    {name: 'May', meta: 23, monto: 10, anterior: 12.5},
    {name: 'Jun', meta: 22, monto: 10, anterior: 11},
    {name: 'Jul', meta: 21, monto: 4, anterior: 10},
    {name: 'Ago', meta: 20, monto: 4.5, anterior: 12},
    {name: 'Sep', meta: 20, monto: 4.7, anterior: 11},
    {name: 'Oct', meta: 20, monto: 4.78, anterior: 12},
    {name: 'Nov', meta: 20, monto: 4.79, anterior: 12.5},
    {name: 'Dic', meta: 24.09, monto: 4.79, anterior: 11},
  ]
};



// WEBPACK FOOTER //
// ./src/reducers/chart-reducers/mRecoveryReducers.js